import React from 'react';
import { Toast } from 'react-bootstrap';
import './style.css';

interface ToastNotificationProps {
  status: number;
  message: string;
  onClose: () => void;
}

const ToastNotification: React.FC<ToastNotificationProps> = ({
  status,
  message,
  onClose,
}) => {
  const getStatusClass = () => {
    if (status === 202) return 'info';
    if (status >= 200 && status < 300) return 'success';
    if (status >= 400 && status < 500) return 'warning';
    if (status >= 500) return 'error';
    return 'info';
  };

  const getStatusIcon = () => {
    switch (getStatusClass()) {
      case 'success':
        return '✓';
      case 'warning':
        return '⚠';
      case 'error':
        return '✕';
      case 'info':
      default:
        return 'ℹ';
    }
  };

  const getStatusTitle = () => {
    switch (status) {
      case 202:
        return 'Processando...';
      case 200:
      case 201:
        return 'Operação concluída com sucesso';
      case 400:
      case 401:
      case 403:
        return 'Atenção';
      case 500:
        return 'Erro';
      default:
        return 'Informação';
    }
  };

  // Erros/avisos (>= 400) NÃO somem sozinhos: o usuário precisa ler/copiar/printar
  // a mensagem (feedback: "não consegui tirar print do erro"). Só fecham no ✕.
  const isPersistente = status >= 400;
  const autoHideDelay = status === 202 ? 30000 : 4000;

  return (
    <div className="toast-container">
      <Toast
        show
        onClose={onClose}
        autohide={!isPersistente}
        delay={autoHideDelay}
        className={`hana-toast hana-toast-${getStatusClass()}`}
      >
        <Toast.Header className="hana-toast-header" closeButton={isPersistente}>
          <strong className="me-auto">
            <span className="hana-toast-icon">{getStatusIcon()}</span>
            {getStatusTitle()}
          </strong>
        </Toast.Header>

        <Toast.Body className="hana-toast-body">
          {message}
        </Toast.Body>
      </Toast>
    </div>
  );
};

export default ToastNotification;
